<template>
  <ListSelectInput
    :label="$t('glossary.title.branch') | capitalize"
    :size="Math.max(2, Math.min(6, branches && branches.length))"
    :options="branchOptions"
    :get-name="branch => branch.name"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
import { ListSelectInput } from "@apphq/vue-form";

export default {
  components: {
    ListSelectInput
  },
  props: {
    branches: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      default: null
    }
  },
  computed: {
    branchOptions() {
      return (
        this.branches &&
        [...this.branches].sort((a, b) =>
          a.name > b.name ? 1 : a.name < b.name ? -1 : 0
        )
      );
    }
  }
};
</script>

<style></style>
